<template>
  <div :class="ishui?'qzhui':'qz'">
<!--    <div id="top">-->
<!--      <img src="../assets/images/main/danghuiicon.png" class="center" @click="open()"/>-->
<!--    </div>-->
    <component :is="menutop" v-bind:islan="islan"></component>
    <div class="allcontent" id="aa1">
    <component :is="mainPage" v-bind:idd="idd" v-bind:search="search" v-bind:page="page" v-bind:searchtype="searchtype"></component>
    <BOTTOM></BOTTOM>
    </div>
  </div>
</template>

<script>
  import MenuTop from './menuTop'
  import Bottom from './bottom'
  import MainPage from './mainPage'
    export default {
        name: "index",
        components:{
            'BOTTOM':Bottom
        },
        mounted(){
            document.body.style.backgroundColor="#ededed";
        },
        data(){
            return{
                mainPage:MainPage,
                menutop:MenuTop,
                idd:0,
                islan:false,  //是否内网
                search:'',
                page:'',
                searchtype:'',
                ishui:false   //是否首页置灰
            }
        },
        methods:{
            changeIslan(islan){
                this.islan=islan;
            },
            changeContent(artid){
                this.idd=artid;
                // let routeUrl = this.$router.resolve({
                //   path: '/news',
                //   query: { id: artid }
                // })
                // window.open(routeUrl.href,'_blank');
                this.mainPage=()=>import('@/components/content');
            },
            changeClsList(id){
                this.idd=id;
                this.page=1;
                this.ishui=false;
                if(id=='165'|id=='166'|id=='167'|id=='168'|id=='169'|id=='170'|id=='206'){
                    this.mainPage=()=>import('@/components/partList');
                }else {
                    this.mainPage=()=>import('@/components/clslist');
                }
            },
            changeClsListBypage(id){
                this.idd=id;
                this.ishui=false;
                if(id=='165'|id=='166'|id=='167'|id=='168'|id=='169'|id=='170'|id=='206'){
                    this.mainPage=()=>import('@/components/partList');
                }else {
                    this.mainPage=()=>import('@/components/clslist');
                }
            },
            changeIndex(){
                this.ishui=false;
                this.mainPage=()=>import('@/components/mainPage');
            },
            changeHtml(com){
                this.ishui=false;
                this.mainPage=()=>import('@/components/'+com);
            },
            // toorglist(id){
            //     this.ishui=false;
            //     this.idd=id;
            //     this.mainPage=()=>import('@/components/zzjg');
            // },
            changePartList(id){
                this.ishui=false;
                this.idd=id;
                this.mainPage=()=>import('@/components/partList');
            },
            // changeZzjgorglist(id){
            //   this.idd=id;
            //   this.ishui=false;
            //   this.mainPage=()=>import('@/components/zzjg');
            // },
            toSearch(type,text,page){
                this.searchtype=type;
                this.search=text;
                this.page=page;
                this.ishui=false;
                this.mainPage=()=>import('@/components/searchlist');
            },
            changeSearchList(){
                this.ishui=false;
                this.mainPage=()=>import('@/components/searchlist');
            },
            toSearchContent(type,text,page,id){
                this.idd=id;
                this.ishui=false;
                this.searchtype=type;
                this.search=text;
                this.page=page;
                this.mainPage=()=>import('@/components/contentSearch');
                // let routeUrl = this.$router.resolve({
                //   path: '/news',
                //   query: { id: this.idd }
                // })
                // window.open(routeUrl.href,'_blank');
            // },
            // open() {
            //   this.$confirm('您访问的链接即将离开“广东省水科院”门户网站 确认继续？', '是否跳转到外部链接...', {
            //     distinguishCancelAndClose: false,
            //     confirmButtonText: '继续访问',
            //     cancelButtonText: '放弃'
            //   }).then(() => {
            //         window.open("http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm",'_blank');
            //   })
            //     .catch(action => {
            //
            //     });
            }
            // changeShow(ishui){
            //   this.ishui=ishui;
            // }
        }
    }
</script>

<style scoped>
  .allcontent{
    width: 100%;
    align-items: center;
    font-family: "Microsoft YaHei";
  }

  .qz{
    /*background:#f2f2f2 url(../assets/images/main/gdsky_body.jpg) no-repeat;*/
    min-width:1400px;
    max-width:1920px;
    width: 100%;
    margin:0px auto;

  }
  .qzhui{
    /*background:#f2f2f2 url(../assets/images/main/gdsky_body.jpg) no-repeat;*/
    min-width:1250px;
    max-width:1920px;
    width: 100%;
    margin:0px auto;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
  //-ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    -webkit-filter: grayscale(1);
  }
  /*top{*/
  /*  width: 1230px;*/
  /*  !*min-width:1230px;*!*/
  /*  height: 85px;*/
  /*  margin:0px auto;*/
  /*  text-align: right;*/
  /*  padding: 14px 5px 0 0;*/
  /*}*/
  </style>



// WEBPACK FOOTER //
// src/components/index.vue